class Template {
  constructor({
    id = '',
    name = '',
    supplier = '',
    image = '',
    model = '',
    pid = null,
    regions = [],
    createdAt = '',
    updatedAt = '',
  }) {
    this.id = id;
    this.name = name;
    this.supplier = supplier;
    this.image = image;
    this.model = model;
    this.pid = pid;
    this.regions = regions;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}

export default Template;
